<template>
    <div class="planne-link-selector">
        <div class="row">
            <div class="col">
                <div class="link-type" v-on:click="onSelect('payment')">
                    <div class="title">Link de Pagamento</div>
                    <div class="description">Cobre um valor definido de um cliente utilizando o mesmo fluxo de pagamento do ecommerce</div>
                </div>
            </div>
            
            <div class="col">
                <div class="link-type" v-on:click="onSelect('sale')">
                    <div class="title">Link de Venda</div>
                    <div class="description">Faça uma venda que cria uma reserva e envia vouchers assim que o pagamento é feito</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    components: {  },
    props: {
        onSelect: { type: Function },
    },
    data() {
        return {
        };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
    .link-type {
        border: 1px solid #ccc;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
        margin-bottom: 20px;
        height: 100%;
    
        .title {
            font-size: 18px;
            font-weight: bold;
        }
        .description {
            font-size: 14px;
            color: #666;
        }
    }
</style>
